// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2PY1g","select":"styles_select__1TiSk"};